{
  "open": "Otwórz czat",
  "unread_one": "{count} nieprzeczytana wiadomość",
  "unread_few": "{count} nieprzeczytane wiadomości",
  "unread_many": "{count} nieprzeczytanych wiadomości",
  "unread_other": "{count} nieprzeczytanej wiadomości",
  "close": "Zamknij"
}
